import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { HealthSystemPaymentInformationv2 } from 'src/app/physician/models/healthSystemPaymentInformation';
import { SideBarInitializeParameters } from 'src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters';
import { SetupCreditCardFormComponent } from '../../setup-checkout/setup-CreditCard-form/setup-CreditCard-form.component';

@Component({
  selector: 'app-credit-card-view',
  templateUrl: './credit-card-view.component.html',
  styleUrls: ['./credit-card-view.component.scss']
})
export class CreditCardViewComponent implements OnInit {

  @Input()
  healthSystemPaymentInformation: HealthSystemPaymentInformationv2;

  @Output()
  creditCardUpdated = new EventEmitter();
  
  constructor(private commonService : CommonService) { }

  ngOnInit() {
  }

  showMaskedCreditCard() {
    return this.healthSystemPaymentInformation != null ;
  }

  AddEditCreditCard()
  {
    const addPracticeManagerData = <SideBarInitializeParameters> {
      componentType: SetupCreditCardFormComponent, 
      onClose : this.creditCardUpdated // this.onClosePracticeManagerSideBar
    };
    this.commonService.rightSideBarComponent$.next(addPracticeManagerData);
  }


}
